import {VuexModule, Action, Mutation} from 'vuex-module-decorators';
import {EntityData} from '@/interfaces/config';
import {httpClient} from '@/api/baseApi';

/*
    Динамический модуль хранилища vuex для работы объектами (в БД)
*/

async function loadEntities(routeName: string, etitieName: string): Promise<EntityData[]> {
  let entityData: EntityData[] = [];
  const {data} = await httpClient.get(routeName);
  if (data && data[etitieName]) entityData = JSON.parse(data[etitieName]);
  return entityData;
}

async function removeEntity(routeName: string, etitieName: string, id: any) {
  let entityData: EntityData[] = [];
  const {data} = await httpClient.get(routeName);
  if (data && data[etitieName]) entityData = JSON.parse(data[etitieName]);
  entityData = entityData.filter((x: EntityData) => x.id !== id);
  await httpClient.put(routeName, {...data, [etitieName]: JSON.stringify(entityData)});
}

async function saveEntity(routeName: string, etitieName: string, model: EntityData) {
  let entityData: EntityData[] = [];
  const {data} = await httpClient.get(routeName);
  if (data && data[etitieName]) entityData = JSON.parse(data[etitieName]);
  entityData = entityData.filter((x: EntityData) => x.id !== model.id);
  entityData.push(model);
  await httpClient.put(routeName, {...data, [etitieName]: JSON.stringify(entityData)});
}

async function saveNewEntity(routeName: string, etitieName: string, model: EntityData) {
  let entityData: EntityData[] = [];
  const {data} = await httpClient.get(routeName);
  if (data && data[etitieName]) entityData = JSON.parse(data[etitieName]);
  const id = entityData.length ? Math.max(...(entityData.map(x => x.id) as [])) + 1 : 1;
  model.id = id;
  entityData.push(model);
  await httpClient.put(routeName, {...data, [etitieName]: JSON.stringify(entityData)});
}

export class EntityDBModule extends VuexModule {
  public entities: EntityData[] = [];

  protected routeName!: string;
  protected etitieName!: string;

  get all(): EntityData[] {
    return this.entities;
  }

  @Mutation
  setAll(entities: EntityData[]) {
    this.entities = entities;
  }

  //Получение списка объектов с БД
  @Action
  public async fetchAll(transformGet: Function) {
    try {
      const data = await loadEntities(this.routeName, this.etitieName);
      const transformData: EntityData[] = data.map((elem: any) => transformGet(elem));
      await this.context.commit('setAll', transformData);
      return Promise.resolve();
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }

  //Получение модели для создания объекта
  @Action
  public async create(
    getCreate: Function,
    transformCreateEdit: Function,
  ): Promise<{data: EntityData}> {
    try {
      const data = getCreate();
      const transformData = transformCreateEdit(data);
      return {data: transformData};
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }

  //Получение модели для редактирования объекта
  @Action
  public async edit(id: any, transformCreateEdit: Function): Promise<{data: EntityData}> {
    try {
      const data = await loadEntities(this.routeName, this.etitieName);
      const item = data.filter((x: EntityData) => x.id === id)[0];
      const transformData = transformCreateEdit(item);
      transformData.id = id;
      return {data: transformData};
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }

  //Удаление объекта
  @Action
  public async delete(id: any) {
    try {
      return removeEntity(this.routeName, this.etitieName, id);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }

  //Создание/реактирование объекта
  @Action
  public async save(model: EntityData, transformSave: Function) {
    try {
      const transformModel = transformSave(model);
      if (model.id) return saveEntity(this.routeName, this.etitieName, transformModel);
      else return saveNewEntity(this.routeName, this.etitieName, transformModel);
    } catch (e) {
      console.log(e);
      return Promise.reject(e);
    }
  }
}
